export const discoRoute = 'discover';
export const networkUpdatesRoute = 'updates';
export const yourPostsRoute = 'your-posts';
export const discoNetworkUpdatesRoute = `${discoRoute}/${networkUpdatesRoute}`;
export const discoYourPostsRoute = `/${discoRoute}/${yourPostsRoute}`;

export { getDiscoDetailViewRoute } from './detail-view';
